<template>
  <div class="OJProblemManagement">
    <div style="background-color: #fff;">
      <div style="padding:10px;font-size: 14px;">
        <div style="position: relative;font-size: 14px;">
          <div style="position: absolute; z-index: 3;width:25%;height: calc(100% - 20px);border: 1px solid #fff;margin-top: 7px;margin-left: 7px;border-radius: 5px;background: #fff;">
            <!-- <div style="text-align: center; font-size: 1.1vw;font-weight: bold;margin-top: 5px;">欢迎回来</div> -->
            <div style="width: 100%;overflow: hidden;">
              <el-row :gutter="10">
                <el-col :span="8">
                  <div style="margin-top: 1vw; text-align: right;font-size: 1.2vw;font-weight: 600;color: #51684B;">
                    <p><span v-if="yue == '01'">一</span></p>
                    <p><span v-if="yue == '02'">二</span></p>
                    <p><span v-if="yue == '03'">三</span></p>
                    <p><span v-if="yue == '04'">四</span></p>
                    <p><span v-if="yue == '05'">五</span></p>
                    <p><span v-if="yue == '06'">六</span></p>
                    <p><span v-if="yue == '07'">七</span></p>
                    <p><span v-if="yue == '08'">八</span></p>
                    <p><span v-if="yue == '09'">九</span></p>
                    <p><span v-if="yue == '10'">十</span></p>
                    <p>
                      <span v-if="yue == '11'">
                        <p>十</p>
                        <p style="line-height: 2px;">一</p>
                      </span>
                    </p>
                    <p>
                      <span v-if="yue == '12'">
                        <p>十</p>
                        <p style="line-height: 14px;">二</p>
                      </span>
                    </p>
                    <p>月</p>
                    <p><span v-if="yue == '01'">大</span></p>
                    <p><span v-if="yue == '02'">平</span></p>
                    <p><span v-if="yue == '03'">大</span></p>
                    <p><span v-if="yue == '04'">小</span></p>
                    <p><span v-if="yue == '05'">大</span></p>
                    <p><span v-if="yue == '06'">小</span></p>
                    <p><span v-if="yue == '07'">大</span></p>
                    <p><span v-if="yue == '08'">大</span></p>
                    <p><span v-if="yue == '09'">小</span></p>
                    <p><span v-if="yue == '10'">大</span></p>
                    <p><span v-if="yue == '11'">小</span></p>
                    <p><span v-if="yue == '12'">大</span></p>
                  </div>
                </el-col>
                <el-col :span="8" style="font-size: 14px;">
                  <div style="text-align: center;font-size:4.8vw;font-weight: bold; color: #51684B;">
                    {{ ri }}
                  </div>
                </el-col>
                <el-col :span="8">
                  <div style="margin-top: 1vw;text-align: left;font-size: 1.2vw;font-weight: 600;color: #51684B;">
                    <p>星</p>
                    <p>期</p>
                    <p>
                      <span v-if="week == '星期一'">一</span>
                      <span v-if="week == '星期二'">二</span>
                      <span v-if="week == '星期三'">三</span>
                      <span v-if="week == '星期四'">四</span>
                      <span v-if="week == '星期五'">五</span>
                      <span v-if="week == '星期六'">六</span>
                      <span v-if="week == '星期日'">日</span>
                    </p>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div style="font-size: 14px;text-align: center;">
              <p>
                <span style="font-size: 12px;">距</span>
                <span style="font-weight: bold;"> CSP-J/S 2025 第一轮 </span>
                <span style="font-size: 12px;">还剩</span><span style="font-weight: bold;"> {{ time1 }} 天</span>
              </p>
              <p>
                <span style="font-size: 12px;">距</span>
                <span style="font-weight: bold;"> CSP-J/S 2025 第二轮 </span>
                <span style="font-size: 12px;">还剩</span><span style="font-weight: bold;"> {{ time2 }} 天</span>
              </p>
            </div>
          </div>
          <el-image style="width: 100%;" src="https://wugecdn.steam.fun/resources/static/oj_rank.jpeg" fit="fill">
          </el-image>
        </div>
      </div>
      <div class="clearfix " style="padding: 0 10px; margin-top: 20px;">
        <div class="fl" style="cursor: pointer;">
          <span style="float:right; font-size:1.5vw;margin-left:5px;font-weight:bold;line-height: 50px;">
            <span v-if="tabPosition1 == '0'">全国排名</span>
            <span v-else>校区排名</span>
          </span>
          <svg style="float:right;" t="1658478029899" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9697" width="50" height="50">
            <path d="M448.8 622.8h126.5v126.5H448.8z" fill="#FFB300" p-id="9698"></path>
            <path d="M609.7 796.8H414.3v-61.2c0-11.5 9.4-20.9 20.9-20.9h153.7c11.5 0 20.9 9.4 20.9 20.9v61.2z" fill="#FFCA28" p-id="9699"></path>
            <path d="M708.1 1016.2H315.9c-11.5 0-20.9-9.4-20.9-20.9V817.2c0-11.5 9.4-20.9 20.9-20.9h392.3c11.5 0 20.9 9.4 20.9 20.9v178.1c-0.1 11.6-9.4 20.9-21 20.9z" fill="#455A64" p-id="9700"></path>
            <path d="M638.3 964H385.7c-5.8 0-10.4-4.7-10.4-10.4V852.7c0-5.8 4.7-10.4 10.4-10.4h252.6c5.8 0 10.4 4.7 10.4 10.4v100.8c0 5.8-4.6 10.5-10.4 10.5z" fill="#CFD8DC" p-id="9701"></path>
            <path d="M257.2 115.8v284.8c-83.8-11.7-148.5-83.8-148.5-170.8v-114h148.5m52.2-52.2H98.2c-23.1 0-41.8 18.7-41.8 41.8v124.5C56.4 354 157 454.6 281.1 454.6h28.3v-391zM915.3 115.8v108.8c0 88-64.4 161.3-148.5 175.2v-284h148.5m10.5-52.2H714.6v390.9h23.1c126.9 0 229.8-102.9 229.8-229.8V105.4c0.1-23.1-18.7-41.8-41.7-41.8z" fill="#FFB300" p-id="9702"></path>
            <path d="M512 647.9c-162.7 0-294.6-131.9-294.6-294.6V27.6c0-10.9 8.9-19.8 19.8-19.8h549.5c10.9 0 19.8 8.9 19.8 19.8v325.7C806.6 516 674.7 647.9 512 647.9z" fill="#FFCA28" p-id="9703"></path>
            <path d="M787.3 458.4L640.1 265 433.6 413l167 221.4c43.9-14.5 74.6-33.9 103.9-58.3 34.9-29.1 62.9-67.8 82.8-117.7z" fill="#FFB806" p-id="9704"></path>
            <path d="M522.3 178.3l31.3 63.3c1.5 3.1 4.5 5.2 7.9 5.7l69.9 10.2c8.6 1.2 12 11.8 5.8 17.8l-50.6 49.3c-2.5 2.4-3.6 5.9-3 9.2l11.9 69.6c1.5 8.5-7.5 15-15.2 11L512.9 379l-67.4 35.4c-7.7 4-16.6-2.5-15.2-11l11.9-69.6c0.6-3.4-0.5-6.8-3-9.2l-50.6-49.3c-6.2-6-2.8-16.6 5.8-17.8l69.9-10.2c3.4-0.5 6.3-2.6 7.9-5.7l31.3-63.3c3.9-7.8 15-7.8 18.8 0z" fill="#FFF8E1" p-id="9705"></path>
          </svg>
        </div>

        <div class="fr" style="margin-top: 5px;">
          <el-radio-group v-model="tabPosition" size="mini" @change="search">
            <el-radio-button label="4">近一年</el-radio-button>
            <el-radio-button label="3">近一月</el-radio-button>
            <el-radio-button label="2">近一周</el-radio-button>
            <el-radio-button label="1">昨 日</el-radio-button>
          </el-radio-group>
        </div>
        <div class="fr" style="margin-top: 5px;margin-right: 10px;">
          <el-radio-group v-model="tabPosition1" size="mini" @change="search">
            <el-radio-button label="0" v-if="$store.state.user.schoolInfo.ojRankTotalAuth">全国</el-radio-button>
            <el-radio-button label="1">本校</el-radio-button>
          </el-radio-group>
        </div>
        <div style="text-align: center;line-height: 50px;font-weight: 600; font-size: 0.9vw;">
          已有
          <span style="color: #693CBD;font-size: 16px;font-weight: bold;">
            {{ total }}
          </span>
          人 参与排名 你的排名 第<span style="color: #895049; font-size: 16px;font-weight: bold;">
            <span v-if="$store.state.user.identity === 1&&!selfOjTotalRank.rank || $store.state.user.identity === 2&&!selfOjTotalRank.stu_rank"> -- </span>
            <span v-else>
              <span v-if="tabPosition1 == '0'">
                {{ $store.state.user.identity === 1?selfOjTotalRank.rank:selfOjTotalRank.stu_rank }}
              </span>
              <span v-else>{{ $store.state.user.identity === 1?selfOjTotalRank.school_rank: selfOjTotalRank.stu_school_rank}}</span>
            </span> </span>位
          <span class="btn" v-if="tabPosition1 != '0'" style="color: #409EFF;margin-left: 10px;cursor: pointer;" @click="copyUrl">分享到微信</span>
        </div>
      </div>
      <div class="main">
        <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ color: '#909399' }">
          <el-table-column prop="rank" label="排名" width="80">
            <template slot-scope="scope">
              <span v-if="tabPosition1 == '0'">{{ $store.state.user.identity === 1?scope.row.rank:scope.row.stu_rank }}</span>
              <span v-else>{{ $store.state.user.identity === 1? scope.row.school_rank : scope.row.stu_school_rank }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="头像">
            <template slot-scope="scope">
              <div style="border-radius: 50%; overflow: hidden; width: 25px;height: 25px;">
                <img :src="scope.row.headImgUrl" style="width: 100%;height: 100%" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span v-if="scope.row.stu_user_id == null" style="color: #FFB806;">{{ scope.row.name }}</span>
              <span v-else>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="schoolName" label="学校" show-overflow-tooltip width="300">
          </el-table-column>

          <el-table-column label="通过题目" prop="correct_problems">
          </el-table-column>
          <el-table-column label="正确提交" prop="correct_submissions">
          </el-table-column>

          <el-table-column prop="total_submissions" label="总提交">
          </el-table-column>

          <el-table-column label="通过率">
            <template slot-scope="scope">
              {{
                (
                  (scope.row.correct_submissions /
                    scope.row.total_submissions) *
                  100
                ).toFixed(2) + '%'
              }}
              <!-- <el-progress
                                :percentage="(scope.row.correct_submissions / scope.row.total_submissions).toFixed(2) * 100"></el-progress> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="clearfix" style="margin-top: 20px;">
          <div class="fr" style=" text-align: right">
            <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ojGetTotalRank } from '@/api/educational.js'
import moment from 'moment'
import Clipboard from 'clipboard'
import md5 from 'js-md5'

require('moment/locale/zh-cn')
export default {
  data() {
    return {
      md5TXt: '',
      md5TXt1: '',
      returnObj: {},
      time1: '',
      time2: '',
      selfOjTotalRank: {},
      page_no: 1,
      page_size: 10,
      total: 0,
      tabPosition1: '0',
      tabPosition: '4',
      ri: '',
      yue: '',
      week: '',
      tableData: [],
      url: '',
    }
  },
  mounted() {
    // console.log(window.location.protocol + "//" + window.location.host + '/shareRanking' + '?' + 'schoolid=' + this.$store.state.user.schoolInfo.id, 1245)
    if (!this.$store.state.user.schoolInfo.ojRankTotalAuth) {
      this.tabPosition1 = '1'
    }

    let m1 = moment()
    let m2 = moment('2025-09-21')
    let m3 = moment('2025-10-26')

    console.log(m2.diff(m1, 'day'), 123456)
    this.time1 = m2.diff(m1, 'day')
    this.time2 = m3.diff(m1, 'day')

    this.yue = moment().format('MM')
    this.ri = moment().format('DD')
    const moment1 = require('moment')
    moment1.locale('zh-cn')
    this.week = moment().format('dddd')
    console.log(this.week, 123456)
    this.ojGetTotalRank()
    console.log(this.selfOjTotalRank.rank, 123456)
  },
  methods: {
    copyUrl() {
      this.md5TXt = md5(this.$store.state.user.schoolInfo.id.toString())
      this.md5TXt1 = md5(this.md5TXt)
      console.log(this.md5TXt1, 12454)
      this.url =
        `${window.location.protocol}//${window.location.host}/shareRanking?schoolid=${this.$store.state.user.schoolInfo.id}&code=${this.md5TXt1}&isTch=${this.$store.state.user.identity == 1}`
      // window.location.protocol +
      // '//' +
      // window.location.host +
      // '/shareRanking' +
      // '?' +
      // 'schoolid=' +
      // this.$store.state.user.schoolInfo.id +
      // '&code=' +
      // this.md5TXt1 + '&isTch=' + this.$store.state.user.identity == 1
      const path = this.url // 这里替换成你想要复制的路径
      console.log(path)
      let clipboard = new Clipboard('.btn', {
        text: function () {
          return path
        },
      })
      clipboard.on('success', (e) => {
        this.$message.success('分享链接已复制!')
        console.log('已成功复制到剪贴板')
        console.log(e, 12465)

        e.clearSelection()
        this.$nextTick(() => {
          clipboard.destroy()
        })
      })
      clipboard.on('error', (e) => {
        console.log(e)
        console.error('无法复制到剪贴板')
      })
    },
    // changeTime(val) {
    //     console.log(val, 123456);
    //     console.log(this.tabPosition, 123456);
    //     if (val == '1') {
    //         // 近一年
    //         console.log(moment().subtract(1, 'years').format('YYYY-MM-DD 00:00:00'));
    //         console.log(moment().format('YYYY-MM-DD 23:59:59'));
    //     }
    //     if (val == '2') {
    //         //近一个月
    //         console.log(moment().subtract(1, 'months').format('YYYY-MM-DD 00:00:00'));
    //         console.log(moment().format('YYYY-MM-DD 23:59:59'));

    //     }
    //     if (val == '3') {
    //         //近一周
    //         console.log(moment().day(moment().day() - 6).format('YYYY-MM-DD 00:00:00'));
    //         console.log(moment().format('YYYY-MM-DD 23:59:59'));
    //     }
    //     if (val == '4') {
    //         //昨日
    //         console.log(moment().day(moment().day() - 1).format('YYYY-MM-DD 00:00:00'));
    //         console.log(moment().format('YYYY-MM-DD 23:59:59'));
    //     }
    // },
    handleCurrent(val) {
      this.page_no = val
      this.ojGetTotalRank()
    },
    search() {
      this.page_no = 1
      this.ojGetTotalRank()
    },
    ojGetTotalRank() {
      ojGetTotalRank({
        is_self_school: this.tabPosition1,
        searchType: this.tabPosition,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.tableData = res.ojTotalRankList
        console.log(res, 123456)
        this.total = res.total
        this.selfOjTotalRank = {}
        if (res.selfOjTotalRank != null) {
          this.selfOjTotalRank = res.selfOjTotalRank
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.OJProblemManagement {
  padding: 10px;
  border-radius: 5px;
  font-size: 14px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.top {
  padding: 20px;
  padding-bottom: 0px;
  font-size: 18px;
  font-weight: 300;
  background: #fff;
}

.main {
  margin-top: 10px;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;
}

/deep/ .el-radio-group {
  margin-top: 7px;
}

/deep/ .el-divider--horizontal {
  margin-top: 0px;
}
</style>
